import { inject, prop } from "fw";
import { ConfirmStore } from "state/components/confirm";
import { ConfirmService } from "service/confirm-service";

@inject
export class ConfirmDialog {
    @prop(null) dataId;

    constructor(
        private store: ConfirmStore,
        private confirmService: ConfirmService
    ) {}

    private get isOpen(): boolean {
        return this.store.state.show;
    }

    private get actions(): string[] {
        return this.store.state.content.actions?.length ? this.store.state.content.actions : ["Confirm"];
    }

    private get title(): string {
        return this.store.state.content.title;
    }

    private get message(): string {
        return this.store.state.content.message;
    }

    private reject() {
        this.confirmService.rejectAction();
    }

    private confirm(action: string) {
        this.confirmService.confirmAction(action);
    }
}
